export const profile = {
  name: "Brijesh Chavda",
  role: "Distinguished Architect",
  company: "Walmart Global Tech",
  location: "Bay area, California, United States",
  experience: [
    {
      company: "Walmart Global Tech",
      duration: "6 yrs 6 mos",
      location: "Sunnyvale, California, United States",
      positions: [
        {
          title: "Distinguished Architect",
          period: "Feb 2024 - Present",
          duration: "1 yr 1 mo",
          location: "Sunnyvale, California, United States · Hybrid"
        },
        {
          title: "Principal Software Engineer",
          period: "Sep 2018 - Feb 2024",
          duration: "5 yrs 6 mos",
          location: "Sunnyvale, CA",
          description: "Expert in Azure, Kubernetes, Istio, MicroServices architecture, CI/CD, Cloud security, infra as a code, SRE, distributed systems at scale.",
          skills: [
            "React.js", "Site Reliability Engineering", "DevSecOps", "Docker Products",
            "Kubernetes", "Prometheus", "Linux", "Node.js", "Microsoft Azure", "DevOps",
            "Core Java", "Tailwind CSS", "Istio", "Spring", "JavaScript", "Spring Boot",
            "Terraform", "Thanos", "Next.js", "Java", "Jenkins"
          ]
        }
      ]
    },
    {
      company: "GE Digital",
      title: "Cloud Architect - Predix Cloud Engineering",
      duration: "2 yrs 4 mos",
      period: "Jun 2016 - Sep 2018",
      location: "San ramon, CA",
      responsibilities: [
        "Responsible for end to end architecture/design Predix CI-CD cloud based product.",
        "Responsible for architecture of microservices ecosystem considering service discovery, High Availibility, load balancing.",
        "Responsible for designing infrastructure layer in AWS using ELB, DCOS from mesosphere, GlusterFS.",
        "Responsible for developing microservices using golang, nodejs and spring boot.",
        "Responsible for developing CI/CD ecosystem using pipeline as code, which deploys microservices in docker containers and orchestrates them on aws using DCOS/Marathon/Mesos.",
        "Responsible for designing the ELK stack for application logging and integrating that in docker containers, being used by microservices."
      ],
      skills: [
        "React.js", "Apache Mesos", "Docker Products", "Kubernetes", "Prometheus",
        "Node.js", "DevOps", "Core Java", "Spring", "Spring Boot", "Terraform",
        "Amazon Web Services (AWS)", "Jenkins"
      ]
    },
    {
      company: "Oracle",
      title: "Principal Applications Engineer",
      duration: "3 yrs 6 mos",
      period: "Jan 2013 - Jun 2016",
      location: "Pleasanton CA",
      responsibilities: [
        "Implemented Responsive UI for existing Careers Website for Taleo Business edition using Spring, Hibernate, jQuery, Bootstrap and Freemaker.",
        "Implemented Themes for customization of Careers Website for TBE.",
        "Responsible for writing unit test cases using mockito and jUnit.",
        "Performed high and low level design based on external specifications using Core Java and JEE Design patterns.",
        "Designed and Developed (Patent Pending) extension framework on top of Oracle ADF to support communication to MS Sql server stored procedures, where all the business logic resides.",
        "Designed and implemented (Patent Pending) multi-tenancy support for Learn REST project, to support 800 enterprise customers of Learn product.",
        "Designed and Developed server side REST framework using Java, JEE and Oracle ADF technology for Learn Enterprise (.NET based) product.",
        "Designed and Developed (Patent Pending) Automated Testing tool for REST APIs for Taleo and Learn Enterprise and integrated with Jenkins CI.",
        "Designed and Developed server side REST APIs to support Mobile Application for TBE, using Java, JEE, Spring data and Hibernate.",
        "Developed Fusion TAP plugins using Objective C and XCode for Taleo Enterprise Edition Mobile project.",
        "Designed and setup continuous integration system for XCode build management for Taleo Enterprise Edition Mobile project using Jenkins.",
        "Designed/Evaluated proof of concepts for Enterprise Learn Mobile server side REST project using different technology stacks and presented to VPs and senior architects.",
        "Actively contributed for solving the production issues for Taleo Business Edition Mobile Apis."
      ],
      skills: [
        "Docker Products", "Core Java", "Spring", "Spring Boot", "Jenkins"
      ]
    },
    {
      company: "DIRECTV",
      title: "Java Architect",
      duration: "1 yr 10 mos",
      period: "Mar 2011 - Dec 2012",
      location: "El segundo, CA",
      responsibilities: [
        "Successfully achieved the migration of claims Application from older Java(1.4)/Weblogic 6 platform to latest Java(1.6)/Weblogic 10 platform",
        "Designed, developed and tested Account level claim processing functionality for TrueClaims Application using Struts, JDBC and Oracle PL/SQL.",
        "Principal contributor in laying out the testing strategy of Claims Application, which is highly complex due to its interaction between different Backend resources, for e.g. Billing system, SAP and Mainframe.",
        "Successfully implemented the re-write of TrueClaims backend processing logic as part of Data Archival project.",
        "Experience in configuring Autosys jobs for some of the claims backend processing.",
        "Designed, developed and tested the TaxCredit application using Spring MVC, Hibernate, Design Patterns, Ehcache and Oracle PL/SQL",
        "Key contributor in implementation and deployment of large web applications like TaxCredit and TrueClaims.",
        "Proven track-record of accurately estimating time to completion of major projects, and meeting deadlines.",
        "Acting as Subject Matter Expert for claims application and well experienced with communicating with different business teams.",
        "Provided Production support for claims application."
      ],
      skills: ["Struts", "Servlets", "Core Java", "Spring", "Spring Boot"]
    },
    {
      company: "Brown Brothers Harriman",
      title: "Technical Architect",
      duration: "9 mos",
      period: "Jun 2010 - Feb 2011",
      location: "Greater Boston Area",
      responsibilities: [
        "Successfully designed, implemented and tested different enhancements to existing Security Landing Applications using Core Java, Spring, Hibernate, JMS, IBM MQ server, Shell scripting, Autosys and Oracle PL/SQL.",
        "Managed offshore team of 5 developers and had interaction with offshore team everyday about the project requirements, status and the next steps.",
        "Everyday communicating with the client regarding requirement discussion, demo-ing the application or providing status.",
        "Successfully estimated the efforts required for the project, designed, developed and managed offshore team to achieve the project deliveries."
      ],
      skills: ["Servlets", "Core Java"]
    },
    {
      company: "Fidelity Investments",
      title: "Technical Specialist",
      duration: "3 yrs 6 mos",
      period: "Dec 2006 - May 2010",
      location: "Greater Boston Area",
      responsibilities: [
        "Successfully migrated and decommissioned Stock Options application from C++ to Java backed platform.",
        "Successfully migrated Tax Election functionality from C++ to Java backed platform.",
        "Successfully designed and implemented Online Beneficiary application for Netbenefits using Struts, Web services, REST services, Hibernate, Xerces, EJBs and JMS.",
        "Successfully designed, implemented and tested large scale web applications like Watch list for fidelity.com using Struts, Web services and EJB",
        "Managed team of 5 to 7 developers and had interaction with offshore team everyday about the project requirements, status and the next steps.",
        "Used Clear case version control system to maintain the project code. Responsible for merging the offshore code to the main project branch, review of the code.",
        "Successfully estimated the efforts required for the project, designed, developed and managed offshore team to achieve the project deliveries.",
        "Achieved Dream Team Award for two years continuously.",
        "Achieved Certificate of Achievement for successful completion of Security Mastery Test by Fidelity."
      ],
      skills: ["Struts", "Core Java"]
    },
    {
      company: "AT&T",
      title: "Senior Software Specialist",
      duration: "10 mos",
      period: "Mar 2006 - Dec 2006",
      location: "Saint Louis, MO",
      responsibilities: [
        "Designed and implemented enhancements to Middle ware services group websites using Java, Struts, PERL and shell scripting.",
        "Extensive experience for meeting critical deadlines and putting fixes for critical bugs in production.",
        "Experienced working in challenging environment, due to high visibility of the middleware websites and being used by 30 different teams within AT&T.",
        "Managed offshore team and were responsible for offshore deliveries, meeting deadlines, reviewing of the code and successful production deployment.",
        "Achieved Best Team award from PATNI and received multiple achievement awards from client."
      ],
      skills: ["Servlets", "Core Java"]
    },
    {
      company: "Patni Computer Systems",
      title: "Senior Software Specialist",
      duration: "2 yrs 2 mos",
      period: "Feb 2004 - Mar 2006",
      location: "Pune Area, India",
      responsibilities: [
        "Successfully led and implemented SBC's 411 enhancement projects with team involving 8 to 10 team members.",
        "Provided accurate estimations and met project deadlines for all the SBC projects.",
        "Performed the requirement analysis and presented project architecture design to the client",
        "Successfully implemented NAS consumption forecasting functionality for HITACHI using C, PERL and Shell Scripting.",
        "Satisfactorily designed and implemented Web based CSR functionality for GE credit card services using Core java, Struts, EJB and Web services.",
        "Successfully led the HITACHI's application server named Cosminexus testing project. Wrote and executed test cases for testing Application server functionalities. Executed those test cases on different operating systems like AIX, HP-UX, Sun Solaris, Linux and Windows (Japanese version).",
        "Won the Achievement award for Cosminexus testing project."
      ],
      skills: ["Struts", "Servlets", "Core Java"]
    },
    {
      company: "Net4Nuts Ltd.",
      title: "Founding Engineer/Project Leader",
      duration: "3 yrs 2 mos",
      period: "Jun 2000 - Jul 2003",
      location: "Ahmedabad Area, India",
      responsibilities: [
        "Successfully designed and implemented upcoming startup company's base product named AVTAAR.",
        "Worked as developer as well as project leader for the AVTAAR and managed team of 10 developers.",
        "Implemented AVTAAR using Core java, Struts, EJB and JMS.",
        "Successfully deployed the product on client's JBoss Application server. Also configured the Application server remotely using its administration interface.",
        "Provided demo of AVTAAR to multiple international clients like Jaring from Malasia and Orange from Thailand.",
        "Technically led the team of developers and continuously provided technical expertise and guidance.",
        "Successfully designed and implemented another product for the company named Email2SMS, which was a cool product, which allows to check your emails using SMS."
      ],
      skills: ["Struts", "Servlets", "Core Java"]
    },
    {
      company: "Web@Work",
      title: "Cofounder",
      duration: "1 yr 8 mos",
      period: "Mar 2000 - Oct 2001",
      location: "Ahmedabad Area, India",
      skills: ["Core Java"]
    },
    {
      company: "Upperex Netsolutions",
      title: "Senier Software Engineer",
      duration: "6 mos",
      period: "Jan 2000 - Jun 2000",
      location: "Ahmedabad Area, India",
      responsibilities: [
        "SRS preparation.",
        "Architecture design",
        "Integration of different modules.",
        "Customization as per client's requirement.",
        "Server setup and administration",
        "Configuration of software"
      ],
      skills: ["Struts", "Servlets", "Core Java"]
    },
    {
      company: "Jindal Online Limited",
      title: "Web Developer",
      duration: "9 mos",
      period: "Apr 1999 - Dec 1999",
      location: "Ahmedabad Area, India",
      responsibilities: [
        "SRA and Technical design document Creation.",
        "Coding.",
        "Testing & debugging"
      ],
      skills: ["Servlets", "Core Java"]
    },
    {
      company: "ISRO - Indian Space Research Organization",
      title: "Project Intern",
      duration: "7 mos",
      period: "Sep 1996 - Mar 1997",
      location: "Ahmedabad, Gujarat, India",
      responsibilities: [
        "Developed Defect Management System for Payload Fabrication Facility (Ahmedabad) in Foxpro and Clipper."
      ]
    }
  ],
  email: "brijesh.chavda@gmail.com",
  linkedin: "https://www.linkedin.com/in/brijeshchavda/",
  bio: `
Full stack engineer with more than 26 yrs of experience. 
Have designed and built Samsclub eCommerce infrastructure on Azure using terraform, kubernetes and istio.
Have played major role in setting up best practices around cloud native microservices development and their CI/CD pipelines. 
Have played major role in taking observability of services to next level , by developing in-house tool to show real time health of services running in production based on prometheus metrics. 
Have extensive hands on experience on cloud native micro-services based product development.
Hands on mobile app development using JavaScript/TypeScript based Ionic framework.
Hands on micro-services development using Golang, Python, Ruby and Spring boot frameworks. 
Hands on end to end architecture for CI/CD for micro-services in AWS using Apache Mesos/Marathon on DCOS platform.
Hands on containerization of services using Docker. 
Hands on message driven service development using Apache Kafka, SQS and RabbitMQ.
Hands on creating highly available and scalable environments for services using DCOS and Kubernetes.
Expert in Jenkins DSL using Groovy as well as Jenkins Plugins development.
Have delivered/developed/designed end to end product from conceptualization to the production provisioning hundreds of customers and generating multi million$ revenue per month.
Good hands on Cloud technologies like AWS and GCP.
`,
  skills: [
    {
      category: "Cloud & Infrastructure",
      items: [
        { name: "Azure/AWS/GCP", proficiency: 95, icon: 'cloud.png', color: '#4285F4', label: 'Cloud' },
        { name: "Kubernetes/DCOS", proficiency: 95, icon: 'k8s.png', color: '#326CE5', label: 'K8s' },
        { name: "Terraform", proficiency: 90, icon: 'tf.png', color: '#7B42BC', label: 'TF' },
        { name: "Docker", proficiency: 90, icon: 'docker.png', color: '#2496ED', label: 'Docker' }
      ]
    },
    {
      category: "DevOps & CI/CD",
      items: [
        { name: "Jenkins/Groovy", proficiency: 95, icon: 'jenkins.png', color: '#D24939', label: 'Jenkins' },
        { name: "CI/CD Pipelines", proficiency: 95, icon: 'cicd.png', color: '#40B5A4', label: 'CI/CD' },
        { name: "Prometheus", proficiency: 90, icon: 'prometheus.png', color: '#E6522C', label: 'Prom' , useStyle:false},
        { name: "Istio", proficiency: 90, icon: 'istio.png', color: '#466BB0', label: 'Istio' }
      ]
    },
    {
      category: "Programming Languages",
      items: [
        { name: "JavaScript/TypeScript", proficiency: 95, icon: 'typescript.png', color: '#3178C6', label: 'TS' },
        { name: "Golang", proficiency: 90, icon: 'golang.png', color: '#00ADD8', label: 'Go'},
        { name: "Python", proficiency: 90, icon: 'python.png', color: '#3776AB', label: 'Py' },
        { name: "Java/Spring Boot", proficiency: 90, icon: 'java.png', color: '#007396', label: 'Java' }
      ]
    },
    {
      category: "Frameworks & Technologies",
      items: [
        { name: "Microservices", proficiency: 95, icon: 'ms.png', color: '#FF6B6B', label: 'μSvc' },
        { name: "React/Ionic", proficiency: 90, icon: 'react.png', color: '#61DAFB', label: 'React' },
        { name: "Kafka/RabbitMQ", proficiency: 90, icon: 'kafka.png', color: '#231F20', label: 'Kafka' },
        { name: "Cloud Native", proficiency: 95, icon: 'container.png', color: '#231F20', label: 'Native' }
      ]
    }
  ],
  portfolio: [
    {
      name: "JSON Visualizer",
      description: "Instantly visualize and explore any JSON structure—beautifully and interactively.",
      image: "jsonvisualizer.png",
      url: "https://jsonvisualizer.cbron.app"
    },
    {
      name: "Productivity Builder",
      description: "Design a personalized workflow to conquer complexity and focus on what matters.",
      image: "productivity.png",
      url: "https://productivity.cbron.app"
    },
    {
      name: "Tranquillo",
      description: "Improve your focus and productivity with Pomodoro timer with White Noise",
      image: "tranquillo.png",
      url: "https://tranquillo.cbron.app"
    }   
  ]
}; 